<template>
    <div class="mt-2 mb-5">
        <div v-if="!confirmNewPlanning">
            <button @click="confirmNewPlanning = true" class="button button-ghost-primary"><i class="fa-kit fa-beg-return pe-2"></i> {{$t('general.newPlanning')}}</button>
        </div>
        <div v-if="confirmNewPlanning"> 
            <p>{{$t('general.confirmNewPlanning')}}</p>
            <button @click="confirmNewPlanning = false" class="button button-ghost-secondary"><i class="fa-regular fa-circle-xmark me-2"></i> {{$t('general.cancel')}}</button>
            <button @click="resetPlanning" class="button button-ghost-primary ms-1"><i class="fa-regular fa-circle-check me-2"></i> {{$t('general.yes')}}</button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: "ActionBar",
    emits: ['resetPlanning'],
    data() {
        return {
            confirmNewPlanning: false
        }
    },
    methods: {
        resetPlanning() {
            this.$emit('resetPlanning')
        }
    },
    computed: {
        ...mapGetters({
        })
    }

}
</script>

<style lang="scss" scoped>

</style>